import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Get session_id from URL hash
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/admin/login', { replace: true });
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for session_token
        const response = await fetch(`${API_URL}/api/auth/session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!response.ok) {
          const error = await response.json();
          console.error('Auth failed:', error);
          navigate('/admin/login', { 
            replace: true, 
            state: { error: error.detail || 'Authentication failed' } 
          });
          return;
        }

        const user = await response.json();
        
        // Clear the hash from URL and navigate to admin
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/admin', { replace: true, state: { user } });
        
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/admin/login', { 
          replace: true, 
          state: { error: 'Authentication failed. Please try again.' } 
        });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 text-gold animate-spin mx-auto mb-4" />
        <p className="text-gold text-lg">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
